import "core-js/modules/es6.object.freeze";
import { badge, badgeRefresh } from './badge';
import { card, cardRefresh } from './card';
import { dropdown, dropdownRefresh } from './dropdown';
import { footer, footerRefresh } from './footer';
import { input, inputRefresh } from './input';
import { navigation, navigationRefresh } from './navigation';
import { postPollInfo, postPollInfoRefresh } from './post-poll-info';
export var components = Object.freeze({
  badge: badge,
  card: card,
  dropdown: dropdown,
  footer: footer,
  input: input,
  navigation: navigation,
  postPollInfo: postPollInfo
});
export var componentsRefresh = Object.freeze({
  badge: badgeRefresh,
  card: cardRefresh,
  dropdown: dropdownRefresh,
  footer: footerRefresh,
  input: inputRefresh,
  navigation: navigationRefresh,
  postPollInfo: postPollInfoRefresh
});